import { Fragment, type PropsWithChildren } from "react";
import { Box, Row } from "@hightouch/htui";
import { CARD_PB_WITH_FOOTER, DEFAULT_CARD_PADDING } from "./constants";

export type CardFooterProps = PropsWithChildren<{
  /** Padding value determines footer spacing. Should be consistent with the rest of the card. */
  p?: number;
}>;

/**
 * Footer for `Card` components.
 *
 * If including, be sure to add `pb={CARD_PB_WITH_FOOTER}` to the parent `Card` component.
 */
export const CardFooter = ({
  children,
  p = DEFAULT_CARD_PADDING,
}: CardFooterProps) => {
  return (
    <Fragment>
      <Box mt="auto" />
      <Row
        pt={CARD_PB_WITH_FOOTER}
        mt={p}
        borderTopWidth="hairline"
        borderTopStyle="solid"
        borderColor="base.border"
        px={p}
        mx={-p} // Negative offset makes the border extend the full width of the card
      >
        {children}
      </Row>
    </Fragment>
  );
};
